import { useQuery } from "@tanstack/react-query";
import { getWaterSewageData } from "../../Requests";
import { useAppSelector } from "..";

function useWaterSewageQuery(municipalKey: string, ownerId: string) {
  const access_token = useAppSelector(state => state.auth.user?.access_token) ?? '';

  return useQuery({
    queryKey: ["watersewage", municipalKey],
    queryFn: () => getWaterSewageData(municipalKey, access_token, ownerId),
    enabled: !!access_token,
  });
}

export { useWaterSewageQuery };
